<template>
  <div class="wlx-basic-static-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <!-- <div class="head-logo-con">
          <img src="~assets/images/wlx-basic-logo.png" alt class="logo-img-val">
        </div>-->
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1"> 物流管理1+X试点扩容院校</p>
            <p class="p-title-1">基本情况统计表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ph-baisc-head-main">
      <img
        src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/bWwrCnyQdKFJAZ6b.png"
        alt
      />
    </div>
    <div class="basic-form-main">
      <div class="basic-form-con">
        <el-form>
          <div class="form-label-title">学校信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校名称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolName">
                    <el-input size="small" placeholder="输入学校名称" v-model="schoolName" :disabled="true" style="color:black;"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校层次</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolArrange">
                    <el-select placeholder="请选择学校层次" size="small" v-model="schoolArrange">
                      <el-option label="中职" value="1"></el-option>
                      <el-option label="高职" value="2"></el-option>
                      <el-option label="本科" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校类型</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择学校类型" size="small" v-model="schoolType">
                      <el-option label="国示范" value="1"></el-option>
                      <el-option label="省示范" value="2"></el-option>
                      <el-option label="行业特色校" value="3"></el-option>
                      <el-option label="优质校" value="4"></el-option>
                      <el-option label="本科" value="5"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">省份</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolProvince">
                    <el-select placeholder="请选择省份" size="small" v-model="schoolProvince" @change="getCityList">
                      <el-option
                        v-for="item in privinceData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">城市</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolCity">
                    <el-select placeholder="请选择城市" size="small" v-model="schoolCity" @change="getCityList">
                      <el-option
                        v-for="item in cityList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校地址</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolAddress">
                    <el-input size="small" placeholder="输入学校地址" v-model="schoolAddress"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校邮编</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolEmail">
                    <el-input size="small" placeholder="输入学校邮编" v-model="schoolEmail"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form :model="personFrom" ref="personFrom" :rules="personRule">
          <div class="form-label-title">试点负责人信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">负责人姓名</span>
                <div class="fr form-input-con">
                  <el-form-item prop="personInfo">
                    <el-input
                      size="small"
                      placeholder="请输入负责人姓名"
                      type="personInfo"
                      v-model="personFrom.personInfo"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">负责人职务</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择负责人职务" size="small" v-model="personFrom.personPost">
                      <el-option label="校领导" value="1"></el-option>
                      <el-option label="院系领导" value="2"></el-option>
                      <el-option label="专业负责人" value="3"></el-option>
                      <el-option label="其他" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <div class="sp-form-label fl">
                  <p>
                    <span class="sp-label-start">*</span>
                    负责人手机
                  </p>
                  <p class="p-phone-tip">不要输入空格，多个手机请用逗号隔开</p>
                </div>
                <div class="fr form-input-con">
                  <el-form-item prop="personPhone">
                    <el-input
                      size="small"
                      placeholder="请输入负责人手机"
                      type="personPhone"
                      v-model.trim="personFrom.personPhone"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form>
          <div class="form-label-title">参与证书信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">证书名称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="certifyName">
                    <el-input size="small" placeholder="请输入证书名称" v-model="certifyName" disabled></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">证书等级</span>
                <div class="fr form-input-con">
                  <el-form-item prop="cerfityGrade">
                    <el-select placeholder="请选择证书等级" size="small" v-model="cerfityGrade">
                      <el-option label="初级" value="1"></el-option>
                      <el-option label="中级" value="2"></el-option>
                      <el-option label="高级" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <div class="pc-table-major-content">
                  <el-table
                    :data="tableData3"
                    style="width: 100%"
                    size="small"
                    class="form-table-con"
                  >
                    <el-table-column prop="marjorName" label="对应专业" align="center">
                      <template slot-scope="scope">
                        <el-form-item prop="scope.row.marjorName">
                          <el-input v-model="scope.row.marjorName" size="small"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="近三年招生人数" align="center">
                      <el-table-column prop="totalPersonNum" label="总人数" align="center" width="120">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.totalPersonNum">
                            <el-input
                              v-model.number="scope.row.totalPersonNum"
                              type="number"
                              size="small"
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year1" label="2016年" align="center" width="120">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year1">
                            <el-input v-model.number="scope.row.year1" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year2" label="2017年" align="center" width="120">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year2">
                            <el-input v-model.number="scope.row.year2" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year3" label="2018年" align="center" width="120">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year3">
                            <el-input v-model.number="scope.row.year3" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="phone-table-major-content">
                  <el-table
                    :data="tableData3"
                    style="width: 100%"
                    size="small"
                    class="form-table-con"
                  >
                    <el-table-column prop="marjorName" label="对应专业" align="center">
                      <template slot-scope="scope">
                        <el-form-item prop="scope.row.marjorName">
                          <el-input v-model="scope.row.marjorName" size="small"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="近三年招生人数" align="center">
                      <el-table-column prop="totalPersonNum" label="总人数" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.totalPersonNum">
                            <el-input v-model="scope.row.totalPersonNum" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year1" label="2016年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year1">
                            <el-input v-model.number="scope.row.year1" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year2" label="2017年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year2">
                            <el-input v-model.number="scope.row.year2" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year3" label="2018年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year3">
                            <el-input v-model.number="scope.row.year3" type="number" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="add-table-tr-btn" @click="addTableTr">
                  <i class="wl-icon-tianjia"></i>
                  <span>点击添加一行</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">培训团队专业带头人信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">姓名</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderName">
                    <el-input size="small" placeholder="请输入姓名" v-model="leaderName"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">职务</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderPost">
                    <el-input size="small" placeholder="请输入职务" v-model="leaderPost"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">专业</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderMajor">
                    <el-input size="small" placeholder="请输入专业" v-model="leaderMajor"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">职称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderTitle">
                    <el-input size="small" placeholder="请输入职称" v-model="leaderTitle"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form :model="teamForm" ref="teamForm">
          <div class="form-label-title">培训团队师资信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">团队总人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teamPersonNum"
                    :rules="[
      { required: true, message: '团队总人数'},
      { type: 'number', message: '团队总人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入团队总人数"
                      type="number"
                      auto-complete="off"
                      v-model.number="teamForm.teamPersonNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">高级职称人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="seniorNum"
                    :rules="[
      { required: true, message: '高级职称人数'},
      { type: 'number', message: '高级职称人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入高级职称人数"
                      type="number"
                      v-model.number="teamForm.seniorNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">行业企业专家人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="expertNum"
                    :rules="[
      { required: true, message: '行业企业专家人数'},
      { type: 'number', message: '行业企业专家人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入行业企业专家人数"
                      type="number"
                      v-model.number="teamForm.expertNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">学校专业教师人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teaNum"
                    :rules="[
      { required: true, message: '学校专业教师人数'},
      { type: 'number', message: '学校专业教师人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入学校专业教师人数"
                      type="number"
                      v-model.number="teamForm.teaNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">专职教学管理团队人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teachTeamNun"
                    :rules="[
      { required: true, message: '专职教学管理团队人数'},
      { type: 'number', message: '专职教学管理团队人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入专职教学管理团队人数"
                      type="number"
                      v-model.number="teamForm.teachTeamNun"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">技术服务团队人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="technologyTeamNum"
                    :rules="[
      { required: true, message: '技术服务团队人数'},
      { type: 'number', message: '技术服务团队人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入技术服务团队人数"
                      type="number"
                      v-model.number="teamForm.technologyTeamNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">培训场地建设信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">场地地址</span>
                <div class="fr form-input-con">
                  <el-form-item prop="address">
                    <el-input
                      size="small"
                      placeholder="请输入场地地址"
                      type="address"
                      v-model="teamForm.address"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">场地面积（平米）</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teachArea"
                    :rules="[
      { required: true, message: '场地面积（平米）'},
      { type: 'number', message: '场地面积（平米）'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入场地面积（平米）"
                      type="number"
                      v-model.number="teamForm.teachArea"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">可容纳理论学习人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="stuNum"
                    :rules="[
      { required: true, message: '可容纳理论学习人数'},
      { type: 'number', message: '可容纳理论学习人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入可容纳理论学习人数"
                      type="number"
                      v-model.number="teamForm.stuNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">可容纳实践操作人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="operateNum"
                    :rules="[
                      { required: true, message: '可容纳实践操作人数'},
                      { type: 'number', message: '可容纳实践操作人数'}
                    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入可容纳实践操作人数"
                      type="number"
                      v-model.number="teamForm.operateNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form>
          <div class="form-label-title">近三年完成取证类培训信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-table
                  :data="trainData"
                  :span-method="objectSpanMethod"
                  border
                  style="width: 100%;"
                  size="small"
                  class="form-table-con"
                  show-summary
                  sum-text="总人数"
                >
                  <el-table-column prop="trainGradeName" label="培训班名称" align="center">
                    <template slot-scope="scope">
                      <el-form-item prop="scope.row.trainGradeName">
                        <el-input v-model="scope.row.trainGradeName" size="small"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainNum" label="培训人数" align="center">
                    <template slot-scope="scope">
                      <el-form-item prop="scope.row.trainNum">
                        <el-input type="number" v-model="scope.row.trainNum" size="small"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="add-table-tr-btn" @click="addTrainTable">
                  <i class="wl-icon-tianjia"></i>
                  <span>点击添加一行</span>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form>
          <div class="form-label-title">课程体系建设基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="courseBasicInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
          <div class="form-label-title">实训设备设施基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="equipmentInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
          <div class="form-label-title">管理制度和保障条件基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="managerInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
        </el-form>
        <div class="submit-btn-con">
          <el-button
            size="small"
            type="primary"
            @click="submitData('personFrom','teamForm')"
            :disabled="isSubmit"
          >提交</el-button>
        </div>
      </div>
    </div>
    <!--*作者:王涛
    *时间:2019.04.26
    *用户是否拥有账号?
    *1:未拥有则关闭弹窗继续填写
    *2:已拥有=>{
    *    1:如果已登陆则直接进入后台
    *    2:如果未登陆则弹出登陆页面手动进行登陆
    *   }
    *-->
    <el-dialog title="提示" :visible.sync="IsTipsDialog" :close-on-click-modal="false" width="600px">
      <div class="wlx-is-fill-diaocha-con">
        <p>
          <span>
            您是否已填写过该问卷？如已填过，您可以
            <router-link :to="target()" v-if="IsLogin==true">直接进入</router-link>
            <a style="color:blue;cursor:pointer;" @click="Gologin()" v-if="IsLogin==false">直接进入</a>
            后台编辑相关信息
          </span>
        </p>
        <!-- <p class="p-name-pass-tip-con">* 用户名为负责人手机号,初始密码为手机号的后6位</p> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsTipsDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="IsPhoneDialog" :close-on-click-modal="false" width="80%">
      <div class="wlx-is-fill-diaocha-con">
        <p>如已经填报过，请使用电脑端操作</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsPhoneDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--登陆弹窗-->
    <newLogin :isShow="showObject"></newLogin>
  </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import newLogin from "components/newLogin.vue";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      showObject: {
        isShow: false
      },
      scanVisible: false,
      IsLogin: false,
      IsTipsDialog: false,
      IsPhoneDialog: false,
      isSubmit: false,
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      schoolName: "",
      schoolArrange: "",
      schoolType: "",
      schoolAddress: "",
      schoolEmail: "",
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [
          { required: true, message: "请输入用户账号", trigger: "change" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      },
      personFrom: {
        personInfo: "",
        personPhone: "",
        personPost: ""
      },
      personRule: {
        personInfo: [
          { required: true, message: "请输入负责人姓名及职务", trigger: "blur" }
        ],
        personPhone: [
          { required: true, message: "请输入负责人手机", trigger: "blur" }
        ]
      },
      certifyName: "物流管理",
      cerfityGrade: "",
      tableData3: [
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        },
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        },
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        }
      ],
      leaderName: "",
      leaderPost: "",
      leaderTitle: "",
      leaderMajor: "",

      trainData: [
        {
          trainGradeName: "",
          trainNum: ""
        },
        {
          trainGradeName: "",
          trainNum: ""
        },
        {
          trainGradeName: "",
          trainNum: ""
        }
      ],
      courseBasicInfo: "",
      equipmentInfo: "",
      managerInfo: "",
      trainTotalNum: 0,
      teamForm: {
        teamPersonNum: "",
        seniorNum: "",
        expertNum: "",
        teaNum: "",
        teachTeamNun: "",
        technologyTeamNum: "",
        address: "",
        teachArea: "",
        stuNum: "",
        operateNum: ""
      },
      schoolProvince: "",
      privinceData: [],
      schoolCity:"",
      cityList:[],
    };
  },
  watch: {
    "personFrom.personPhone": function(val) {
      this.personFrom.personPhone = val.replace(/\s+/g, "");
    }
  },
  components: {
    newLogin
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function() {
      return this.$store.state.association;
    }
  },
  created() {
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
    that.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
    this.getProvinceData();
    this.getAuthInfo();
    // if(this.$store.state.auth.userId==""){
    //   this.IsLogin = false;
    // }else{
    //   this.IsLogin = true;
    // }
  },
  methods: {
      // 获取城市 省市联动
      getCityList(){
          this.$http.post("/api/partner/PartnerApplication/getCityList", {
              province:this.schoolProvince
          }).then(rst => {
              if (rst.code > 0) {
                  this.cityList = rst.cityList;
              }
          });
      },
    Gologin() {
      // this.scanVisible = true;
      this.IsTipsDialog = false;
      this.showObject = {
        isShow: true
      };
    },
    login: function() {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/XLogin/Accountlogin", {
          userName: that.ruleForm.userName,
          userPwd: that.ruleForm.password,
          associationId: that.association.Id
        })
        .then(function(rst) {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = that.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            that.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.loadingTip(false);
              // 登录完获取回登录信息跳转
              that.scanVisible = false;
              that.$router.push({
                name: that.target_()
              });
            });
          } else {
            that.loadingTip(false);
            that.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    getAuthInfo() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/getAuthInfo").then(res => {
        if (
          navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          )
        ) {
          that.IsPhoneDialog = true;
        } else {
          that.IsTipsDialog = true;
        }

        if (res.code > 0) {
          this.schoolName = this.userInfo.userSchoolName;
          that.IsLogin = true;
        } else {
          that.IsLogin = false;
        }
      });
    },
    target() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaPilotManager";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "managerIndex";
      }
      return { name: Urlname };
    },
    target_() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaPilotManager";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "managerIndex";
      }
      return Urlname;
    },
    getProvinceData() {
      this.$http
        .post("/api/XOrg/Questionnaire/getAllProvinceList")
        .then(res => {
          if (res.code > 0) {
            this.privinceData = res.province;
          }
        });
    },
    addTableTr() {
      this.tableData3.push({
        marjorName: "",
        totalPersonNum: "",
        year1: "",
        year2: "",
        year3: ""
      });
    },
    addTrainTable() {
      this.trainData.push({
        trainGradeName: "",
        trainNum: "",
        totalNum: ""
      });
    },
    getTableInfo() {
      console.log(this.tableData3);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return {
          rowspan: this.trainData.length,
          colspan: 1
        };
      }
    },
    getSummaries(param) {},
    submitData(person, team) {
      var _this = this;

      var personForm = new Promise(function(resolve, reject) {
        _this.$refs[person].validate(valid => {
          if (valid) {
            resolve();
          } else {
            _this.$message.error("信息填写错误!!");
            return false;
          }
        });
      });

      var teamForm = new Promise(function(resolve, reject) {
        _this.$refs[team].validate(valid => {
          if (valid) {
            resolve();
          } else {
            _this.$message.error("信息填写错误!!");
            return false;
          }
        });
      });

      Promise.all([personForm, teamForm]).then(function() {
        _this.trainData.forEach(val => {
          _this.trainTotalNum = _this.trainTotalNum + Number(val.trainNum);
        });
        _this.isSubmit = true;
        _this.addQuestionnaire();
        // _this.$http
        //   .post("/api/XOrg/Questionnaire/checkInfo", {
        //     SchoolName: _this.schoolName,
        //     CertificateLeavel: _this.cerfityGrade
        //   })
        //   .then(res => {
        //     if (res.code > 0) {
        //       if(res.IsReplace == 1){
        //         _this.$confirm('系统已检测到该学校的试点申报信息, 是否覆盖之前信息?', '提示', {
        //           confirmButtonText: '确定',
        //           cancelButtonText: '取消',
        //           type: 'warning'
        //         }).then(() => {
        //           _this.addQuestionnaire();
        //         }).catch(() => {
        //           // this.$message({
        //           //   type: 'info',
        //           //   message: '已取消'
        //           // });
        //            _this.isSubmit = false;
        //         });
        //       }else{
        //         _this.addQuestionnaire();
        //       }
        //     }else{
        //       _this.$message.warning(res.msg);
        //     }
        //   });
        console.log(_this.trainTotalNum);
      });
    },
    addQuestionnaire() {
      var _this = this;
      _this.isSubmit = true;
      _this.$http
        .post("/api/XOrg/Questionnaire/addQuestionnaire", {
          SchoolName: _this.schoolName,
          SchoolLevel: _this.schoolArrange,
          SchoolType: _this.schoolType,
          Province: _this.schoolProvince,
          City:_this.schoolCity,
          SchoolAddress: _this.schoolAddress,
          SchoolEmail: _this.schoolEmail,
          ResponNameOrJob: _this.personFrom.personInfo,
          Job: _this.personFrom.personPost,
          Phone: _this.personFrom.personPhone,
          Certificate: _this.certifyName,
          CertificateLeavel: _this.cerfityGrade,
          Major: JSON.stringify(_this.tableData3),
          TeaTeamName: _this.leaderName,
          TeaTeamJob: _this.leaderPost,
          TeaTeamTitle: _this.leaderTitle,
          TeaTeamMajor: _this.leaderMajor,
          PersonCount: _this.teamForm.teamPersonNum,
          SeniorCount: _this.teamForm.seniorNum,
          XpertCount: _this.teamForm.expertNum,
          TeaCount: _this.teamForm.teaNum,
          TeachingCount: _this.teamForm.teachTeamNun,
          SkillCount: _this.teamForm.technologyTeamNum,
          Address: _this.teamForm.address,
          Area: _this.teamForm.teachArea,
          StudyCount: _this.teamForm.stuNum,
          TrainCount: _this.teamForm.operateNum,
          TrainSituation: JSON.stringify(_this.trainData),
          TrainSituationCount: _this.trainTotalNum,
          CourseBuildContent: _this.courseBasicInfo,
          DeviceImpleContent: _this.equipmentInfo,
          ManagerContent: _this.managerInfo
        })
        .then(res => {
          if (res.code > 0) {
            const h = _this.$createElement;
            _this.$message({
              message: h("div", null, [
                h("p", null, [
                  h("span", { style: "color: #000" }, "提交成功，可在后台进行修改管理")
                ]),
                h("p", null, [
                  h("span", { style: "color: #000" }, "正在返回到主站...")
                ])
              ]),
              type: "success",
              duration: 6000
            });
            // _this.$message({
            //   message: h("div", null, [
            //     h("p", null, [
            //       h("span", { style: "color: #000" }, "提交成功，可登陆"),
            //       h("span", { style: "color: red" }, res.username),
            //       h("span", { style: "color: #000" }, "账号进行修改管理")
            //     ]),
            //     h("p", null, [
            //       h("span", { style: "color: #000" }, "默认密码为手机号后六位"),
            //       h("span", { style: "color: red" }, res.password),
            //       h("span", { style: "color: #000" }, "正在返回到主站...")
            //     ])
            //   ]),
            //   type: "success",
            //   duration: 6000
            // });
            //  _this.isSubmit = false;
            setInterval(_this.goclpp, 6000);
          }
          // _this.isSubmit = false;
        });
    },
    goclpp() {
      window.location.href = "http://www.clppx.org.cn/wlx/home";
    }
  }
};
</script>

<style lang="scss">
</style>
